export const GET_LIST_RESULTS = (limit: any, skip = 0, tags: string[], preview: boolean) => `
query {
    pageCollection(preview: ${preview}, limit: ${limit}, order: slug_ASC, skip: ${skip} ${
      tags?.length
        ? `, where: {
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_all: [${tags.map((item) => {
                return `"${item}"`;
              })}]
          }
      }
      })`
        : `)`
    }

    {
      total
      items {
        name
        sys {
          id
          firstPublishedAt
          publishedAt
        }
        slug
        teaserTitle
        ivTeaserImage
        teaserText
        teaserLinkText
        isContainer
        content {
          __typename
          ... on Landingpage {
            heading
            preamble
          }
          ... on Standardpage {
            heading
            preamble
            isFundingPage
            openingDate
            closingDate
          }
          ... on Insurancepage {
            heading
            preamble
          }
          ... on InsuranceClaimPage {
            heading
            preamble
          }
          ... on Eventpage {
            heading
            preamble
            publishDate
            startDate
            endDate
            eventCategory
            eventFormat
          }
          ... on Newspage {
            heading
            publishDate
            hidePublishDate
            preamble
            newsType
          }
          ... on Reportpage {
            heading
            publishDate
            reportType
            preamble
          }
        }
      }
    }
  }`;
